import { BlocksIconTag } from 'blocks-nextjs/blocks-web-components/components/icon/icons/tag';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTag = createComponent({ react: React, tagName: 'cat-icon-tag', elementClass: BlocksIconTag });
